import React from 'react';
import './Contact.css';

function Contact() {
  return (
    <div className="contact-page">
      <section className="contact-section section">
        <div className="container">
          <div className="contact-card">
            <h2 className="section-title">Contact Us</h2>
            <p className="contact-text">
              To share your own kind words or memories, please send an email to{' '}
              <a href="mailto:hewsat17@gmail.com">hewsat17@gmail.com</a>.
            </p>
            <a href="mailto:hewsat17@gmail.com" className="btn-virtual">
              Send an Email
            </a>
          </div>
        </div>
      </section>
    </div>
  );
}

export default Contact;
